import { DsChipColorVariant, DsChipIconPosition, DsChipSize, Icons, TableChipConfig } from '@levelaccess/design-system';

import { SharedCommonUtility } from '../../../shared/utils/common.utility';
import { SharedObjectUtility } from '../../../shared/utils/object.utility';

export interface ITrendChipConfig {
  currentValue?: number;
  previousValue?: number;
  isIncreaseImprovement?: boolean;
  showNoChange?: boolean;
  noChangeText: string;
  noChangePrefix?: string;
  increaseAriaLabel?: string;
  decreaseAriaLabel?: string;
}

export class TrendChipUtility {
  public static getVariation(config: Pick<ITrendChipConfig, 'currentValue' | 'previousValue'>): number {
    const variation: number = config?.currentValue - config?.previousValue;

    if (SharedObjectUtility.isNumber(variation)) {
      return variation;
    }

    return 0;
  }

  public static getTrendChipConfig(config: ITrendChipConfig): TableChipConfig | null {
    const variation: number = TrendChipUtility.getVariation(config);

    if (variation === 0) {
      if (config?.showNoChange !== true) {
        return null;
      }

      return {
        text: TrendChipUtility.getNoChangeText(config),
        sortStatus: variation,
        colorVariant: DsChipColorVariant.Primary,
        size: DsChipSize.Small,
      };
    }

    const isIncrease: boolean = variation > 0;

    return {
      text: isIncrease ? `+${variation}` : variation.toString(),
      sortStatus: variation,
      ...TrendChipUtility.getTrendAriaLabelConfig(isIncrease, config),
      colorVariant: TrendChipUtility.getTrendVariant(isIncrease, config?.isIncreaseImprovement === true),
      size: DsChipSize.Small,
      showIcon: true,
      iconPosition: DsChipIconPosition.Left,
      iconName: isIncrease ? Icons.ArrowTrendUp : Icons.ArrowTrendDown,
    };
  }

  private static getTrendVariant(isIncrease: boolean, isIncreaseImprovement: boolean): DsChipColorVariant {
    if (isIncrease) {
      return isIncreaseImprovement ? DsChipColorVariant.Success : DsChipColorVariant.Danger;
    }

    return isIncreaseImprovement ? DsChipColorVariant.Danger : DsChipColorVariant.Success;
  }

  private static getTrendAriaLabelConfig(isIncrease: boolean, config: ITrendChipConfig): Pick<TableChipConfig, 'ariaLabel'> {
    const ariaLabel: string | undefined = isIncrease ? config?.increaseAriaLabel : config?.decreaseAriaLabel;

    return SharedCommonUtility.isNullishOrEmpty(ariaLabel) ? {} : { ariaLabel };
  }

  private static getNoChangeText(config: ITrendChipConfig): string {
    if (SharedCommonUtility.isNullishOrEmpty(config?.noChangePrefix)) {
      return config.noChangeText;
    }

    return `${config.noChangePrefix} ${config.noChangeText}`;
  }
}
